<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("BUTTONS.view_notification_details") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #446e80">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- Start:: Receiver Type Input -->
          <!-- <base-select-input
            col="6"
            :optionsList="receiverTypes"
            :placeholder="$t('PLACEHOLDERS.receiverType')"
            v-model="data.receiverType"
            disabled
          /> -->
          <!-- End:: Receiver Type Input -->

          <!-- Start:: service_providers Type Input -->
          <!-- <base-select-input
            v-if="data.providers && data.receiverType.value === 'provider'"
            col="6"
            :optionsList="data.providers"
            :placeholder="$t('PLACEHOLDERS.service_providers_plural')"
            v-model="data.provider"
            disabled
            multiple
          /> -->
          <!-- End:: Drivers Type Input -->

          <div class="col-12">
            <div class="row">
              <!-- Start:: Title Ar Input -->
              <base-input
                col="6"
                type="text"
                :placeholder="$t('PLACEHOLDERS.titleAr')"
                v-model.trim="data.titleAr"
                disabled
              />
              <!-- End:: Title Ar Input -->

              <!-- Start:: Title En Input -->
              <base-input
                col="6"
                type="text"
                :placeholder="$t('PLACEHOLDERS.titleEn')"
                v-model.trim="data.titleEn"
                disabled
              />
              <!-- End:: Title En Input -->

              <!-- Start:: Content Ar Input -->
              <base-input
                col="6"
                rows="7"
                type="textarea"
                :placeholder="$t('PLACEHOLDERS.contentAr')"
                v-model.trim="data.contentAr"
                disabled
              />
              <!-- End:: Content Ar Input -->

              <!-- Start:: Content En Input -->
              <base-input
                col="6"
                rows="7"
                type="textarea"
                :placeholder="$t('PLACEHOLDERS.contentEn')"
                v-model.trim="data.contentEn"
                disabled
              />
              <!-- End:: Content En Input -->
              <base-input
                col="12"
                type="text"
                :placeholder="$t('PLACEHOLDERS.send_date')"
                v-model.trim="data.date"
                disabled
              />

              <!-- Start:: Notifiable Type Input -->
              <base-input
                col="6"
                type="text"
                :placeholder="$t('PLACEHOLDERS.notifiable_type')"
                v-model.trim="data.notifiableType"
                disabled
              />
              <!-- End:: Notifiable Type Input -->

              <!-- Start:: Notifiable Users List -->
              <base-select-input
                v-if="data.notifiableUsers?.length"
                col="6"
                :optionsList="data.notifiableUsers"
                :placeholder="$t('PLACEHOLDERS.recievers')"
                v-model="data.notifiableUsers"
                disabled
                multiple
              />
              <!-- End:: Notifiable Users List -->
            </div>
          </div>
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "CreateNotification",

  computed: {
    // Start:: Vuex Getters
    ...mapGetters({
      allClientsData: "ApiGetsModule/allClientsData",
      allDriversData: "ApiGetsModule/allDriversData",
    }),
    // End:: Vuex Getters

    receiverTypes() {
      return [
        {
          id: 1,
          name: this.$t("PLACEHOLDERS.service_seeker_singular"),
          value: "client",
        },
        {
          id: 2,
          name: this.$t("PLACEHOLDERS.all_service_seekers"),
          value: "clients",
        },
        {
          id: 3,
          name: this.$t("PLACEHOLDERS.service_provider_singular"),
          value: "provider",
        },
        {
          id: 4,
          name: this.$t("PLACEHOLDERS.all_service_providers"),
          value: "providers",
        },
        {
          id: 5,
          name: this.$t("PLACEHOLDERS.both"),
          value: "both",
        },
      ];
    },
  },

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        titleAr: null,
        titleEn: null,
        contentAr: null,
        contentEn: null,
        date: null,
        notifiableType: null,
        notifiableUsers: [],
      },

      // End:: Data Collection To Send
    };
  },
  methods: {
    // End:: Vuex Actions
    async getNotificationData() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `notification/show/${this.$route.params.id}`,
        });

        const notification = res.data.data.notification;

        this.data.titleAr = notification.data.title.ar;
        this.data.titleEn = notification.data.title.en;
        this.data.contentAr = notification.data.body.ar;
        this.data.contentEn = notification.data.body.en;
        this.data.date = notification.created_at;
        this.data.notifiableType = notification.notifiable_type;

        // Map notifiable users to dropdown format
        if (notification.notifiable && notification.notifiable.length > 0) {
          this.data.notifiableUsers = notification.notifiable.map((user) => ({
            id: user.id,
            name: user.name + " (" + user.email + ")",
          }));
        }
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
  },

  created() {
    // Start:: Fire Methods
    this.getNotificationData();
    // End:: Fire Methods
  },
};
</script>
